



























import Vue from "vue";
import { Component, Prop, Watch, Provide } from "vue-property-decorator";
import L from "leaflet";
import * as esri from "esri-leaflet";
import MapConfig from "../mapConfig.model";
import { CobMarker, MapLayer, TableData, LegendSection } from "../types";
import MapFeatureLayer from "./MapFeatureLayer.vue";
import MapSidepane from "./MapSidepane.vue";
import MapMarker from "./MapMarker.vue";
import "leaflet.fullscreen";
import "leaflet.locatecontrol";
import * as Geocoding from "esri-leaflet-geocoder";
import "esri-leaflet-renderers";
import { GeoJsonProperties } from "geojson";
import "../services/ZoomHomeControl.js";
import * as Vector from "esri-leaflet-vector";
import FeatureLayerData from "../featureLayerData.model";
import { CobMap } from "../services/featureLayerService";


@Component({
  components: { MapFeatureLayer, MapSidepane, MapMarker }
})
export default class CollectionMap extends Vue {
  @Prop() mapconfig!: MapConfig;
  @Prop() markers!: CobMarker[];
  @Prop() marker!: CobMarker;
  @Prop() layers!: MapLayer[];
  map: L.Map | null = null;
  ready: boolean = false;
  legend: LegendSection[] = [];
  legendReady: boolean = false;
  basemapLayer: any = null;
  layerCount: number = 0;
  legendCount: number = 0;
  featureLayers: FeatureLayerData[] = [];
  legendSections: LegendSection[] = [];

  mounted() {
    var vm = this;
    let config: L.MapOptions = {
      zoomControl: false,
      scrollWheelZoom: !L.Browser.mobile,
      preferCanvas: false
    };
     
    if (this.mapconfig.staticMap) {
      config.dragging = false;
      config.touchZoom = false;
    }
    vm.map = new L.Map(this.$el as HTMLElement,config).setView(
      this.mapconfig.center,
      this.mapconfig.zoom
    );

    
    if(this.markers){
      vm.map.setMaxZoom(18);
    }

    if (!this.mapconfig.hideControls) {
      L.control.zoomHome({ position: "bottomright" }).addTo(vm.map);
      L.control
        .fullscreen({
          position: "bottomright",
          forceSeparateButton: true,
          forcePseudoFullscreen: false
        })
        .addTo(vm.map);
      L.control
        .locate({
          position: "bottomright",
          keepCurrentZoomLevel: true,
          drawCircle: false,
          icon: "leaflet-locate-icon",
          showPopup: true
        })
        .addTo(vm.map);
    }

    if (this.mapconfig.showAddressFinder) {
      // @ts-ignore
      var searchControl = Geocoding.geosearch({
        position: "topright",
        collapseAfterResult: false,
        expanded: true,
        zoomToResult: true,
        useMapBounds: true,
        title: "Places",
        placeholder: "Find address or place",
        allowMultipleResults: false,
        searchBounds: L.latLngBounds(
          L.latLng(43.41499112228006, -116.75050735473634),
          L.latLng(43.78791865771154, -115.64706802368165)
        )
      }).addTo(vm.map);

      // create an empty layer group to store the results and add it to the map
      var results = L.layerGroup().addTo(vm.map);
      // listen for the results event and add every result to the map
      searchControl.on("results", function(data: any) {
        results.clearLayers();
        searchControl.clear();
        for (var i = data.results.length - 1; i >= 0; i--) {
          results.addLayer(
            L.marker(data.results[i].latlng, {
              icon: L.icon({
                iconUrl:
                  "https://static.cityofboise.net/scripts/js-libs/esri-leaflet-map/1.0.0/assets/img/map-marker--red.svg"
              })
            })
          );
        }
      });
      searchControl.on("clear", function(data: any) {
        results.clearLayers();
      });
    }

    vm.map.on("enterFullscreen", function() {
      if (vm.map) {
        vm.map.dragging.enable();
      }
    });

    vm.map.on("exitFullscreen", function() {
      if (vm.map && L.Browser.mobile) {
        vm.map.dragging.disable();
      }
    });
    
    //@ts-ignore
    vm.basemapLayer = Vector.vectorBasemapLayer("ArcGIS:" + this.mapconfig.basemap,{apiKey:this.mapconfig.basemapKey}).addTo(vm.map);
    this.ready = true;
    if (this.layers == null && this.markers) {
      this.$emit("dataChanged", null);
    }
  }
 
  onLayerDataLoaded(data: GeoJsonProperties) {
    this.layerCount ++;
    if(this.layerCount == this.layers.length){
      this.$emit("dataChanged", data);
    }    
  }

  onLegendLoaded(data: LegendSection) {
    let vm = this;
    this.legendSections.push(data);
    this.legendCount ++;

     if(this.legendCount == this.layers.length){
       this.layers.forEach(element => {
         //find legend for layer
         let findex = vm.legendSections.findIndex(x => x.id == element.id);
         if(findex >= 0){
          vm.legend.push(this.legendSections[findex]);     
         }

               
       });
     }
  }

  onfeatureLayerLoaded(featureLayerData: FeatureLayerData){
    this.featureLayers.push(featureLayerData);
    this.layerCount ++;

     if(this.layerCount == this.layers.length){
       var count = 0;
       this.layers.forEach(element => {
         element.id == count.toString();
         this.addFeatureLayerToMap(element);         
       });
     }
    
  }

  addFeatureLayerToMap(flayer: MapLayer){

    //find featurelayer
    let mv = this;
    //@ts-ignore
    let findex = this.featureLayers.findIndex(x => x.featureLayer.options.url.replace(/\/$/, '') == flayer.url.replace(/\/$/, ''));
    
    if(findex > -1 && mv.map){
    let featureLayer = this.featureLayers[findex].featureLayer;
    let tableData = this.featureLayers[findex].tableData;
      if(featureLayer && mv.map){
        var flService = new CobMap.FeatureLayerService(featureLayer,mv.map,flayer);
        featureLayer.addTo(mv.map);
        flService.getLegendItems(function(legendItems,error){
          if (legendItems && legendItems.items && legendItems.items.length > 0) {
                mv.onLegendLoaded(legendItems);
                //mv.legendSections.push(legendItems);
          }
        });
        flService.addLabels();
        flService.fitBounds();
        featureLayer.on('load', function () {
          mv.$emit("dataChanged",tableData );
        });
      }    
    }
  }

  setBasemap(basemap: esri.Basemaps) {
    if (this.map) {
      if (this.basemapLayer) {
        this.map.removeLayer(this.basemapLayer);
      }

      this.basemapLayer = esri.basemapLayer(basemap);

      this.map.addLayer(this.basemapLayer);
    }
  }

  //suggest geocode
  //showOnMap - zoom to and open popup

  // changeBasemap(basemaps: esri.Basemaps) {
  //   var basemap = basemaps.value;
  //   this.setBasemap(basemap);
  // }
  
}
